import { render, staticRenderFns } from "./premios.vue?vue&type=template&id=56cb4927&"
import script from "./premios.vue?vue&type=script&lang=js&"
export * from "./premios.vue?vue&type=script&lang=js&"
import style0 from "./premios.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports